
export default {
  props: {
    files: {
      type: Array,
      default: () => []
    },
    namespace: {
      type: String,
      default: 'Tender'
    }
  },

  data () {
    return {
      faq: [],
      selectedFiles: [],
      composer: '',
      currentSource: 0,
      sourcePageSize: 5,
      answering: false,
      conversation: null,
      loading: false
    };
  },
  async fetch () {
    // TODO: uncomment when FAQ is ready
    // await this.loadFaq();
  },

  computed: {
    supportedFiles () {
      const SUPPORTED_EXTENSIONS = ['.pdf'];

      return this.files.filter(file => SUPPORTED_EXTENSIONS.includes(file.extension));
    },

    sortedExchanges () {
      if (!this.conversation) { return []; }

      return [...this.conversation.exchanges].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    },

    sources () {
      const allSources = this.sortedExchanges.flatMap(exchange => exchange.sources);

      return allSources;
    },
    currentSources () {
      return this.sources.slice(this.currentSource * this.sourcePageSize, this.currentSource * this.sourcePageSize + this.sourcePageSize)
        .filter(x => !!x)
        .map(x => ({ ...x, file: this.files.find(file => file.id === x.documentId) }));
    }
  },

  watch: {
    selectedFiles () {
      this.findExistingConversation();
    },

    sourcePageSize () {
      this.currentSource = 0;
    },

    conversation () {
      const { tenderID } = this.$route.params;

      this.currentSource = 0;

      sessionStorage.setItem(`conversation-${tenderID}`, JSON.stringify(this.conversation));
    }
  },

  mounted () {
    this.restoreConversation();
  },

  methods: {
    restoreConversation () {
      const existingConversation = sessionStorage.getItem(`conversation-${this.$route.params.tenderID}`);

      if (existingConversation && existingConversation !== 'null') {
        this.conversation = JSON.parse(existingConversation);
        this.selectedFiles = this.conversation.documents.map(document => this.files.find(file => file.id === document.documentId));
      }
    },

    openPdf (source) {
      const file = source.file ?? this.files.find(file => file.id === source.documentId);
      if (!file) { return; }

      const url = this.$config.publicStorageBaseUrl.replace(/^\/+|\/+$/g, '') +
        '/' +
        file.filePath;

      this.$emit('open', {
        id: file.id,
        url,
        name: file.fileName,
        highlight: source.originalText
      });
    },

    async postSentiment (exchange, sentiment) {
      if (exchange.exchangeType === 'Query') {
        return;
      }

      if (exchange.sentiment === sentiment) {
        sentiment = 'Unknown';
      }

      exchange.sentiment = sentiment;
      await this.$axios.$post(`/alturagptconversation/${this.conversation.id}/exchange/${exchange.id}/sentiment/${sentiment}`);
    },

    async findExistingConversation () {
      try {
        const conversation = await this.$axios.$post('alturagptconversation/find', this.selectedFiles.map(file => ({ documentId: file.id, type: file.namespace ?? this.namespace })));

        if (!conversation) {
          throw new Error('No conversation found');
        }

        this.conversation = conversation;
      } catch {
        this.conversation = null;
      }
    },

    async loadFaq () {
      this.faq = await this.$axios.$get('/alturagptconversation/faq');
    },

    async createChat () {
      this.loading = true;
      const conversation = await this.$axios.$post('/alturagptconversation', {
        documents: this.selectedFiles.map(file => ({ documentId: file.id, type: file.namespace ?? this.namespace }))
      });
      this.loading = false;

      this.conversation = conversation;
    },

    getDescription (file) {
      return `${this.$options.filters.formatFileSize(file.fileByteSize)} - ${this.$options.filters.formatDate(file.publishedAt || file.downloadedAt || file.createdAt)}`;
    },

    async sendQuestion () {
      this.answering = true;
      if (this.conversation === null) {
        await this.createChat();
      }

      const exchange = {
        body: this.composer,
        exchangeType: 'Query',
        createdAt: new Date().toISOString()
      };
      this.conversation.exchanges.push(exchange);
      this.composer = '';

      try {
        const newConversation = await this.$axios.$get(`/alturagptconversation/${this.conversation.id}/ask`, {
          params: {
            question: exchange.body
          }
        });

        this.conversation = newConversation;
      } catch (e) {
        this.$toast({ title: 'Er is iets misgegaan. ik kan op dit moment niet antwoorden. Probeer het later nog eens.', error: true });
        console.error(e);
      }
      this.answering = false;
    }
  }
};
